import { Badge } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import { BodyText } from "@/components/ui/Text";
import type { AVCallSuggestedSnomedCode } from "../../network";

interface AVCallSuggestedConditionRowProps {
  snomedCode: AVCallSuggestedSnomedCode;
  onAdd: (code: AVCallSuggestedSnomedCode) => void;
  isPending: boolean;
  isAdded: boolean;
}

/**
 * Single-SNOMED-code row used when an extracted condition resolved to exactly
 * one candidate. Mirrors the CIQ visual: a labeled row with an Add button
 * that swaps to an "Added" `ai` badge after acceptance.
 */
export const AVCallSuggestedConditionRow = ({
  snomedCode,
  onAdd,
  isPending,
  isAdded,
}: AVCallSuggestedConditionRowProps) => (
  <div className="mt-1 flex items-center justify-between gap-2 w-full px-2 py-1 rounded">
    <BodyText size="sm">{snomedCode.display ?? "—"}</BodyText>
    {isAdded ? (
      <div className="flex items-center shrink-0" style={{ height: 25 }}>
        <Badge variant="ai">
          <BodyText size="xs">Added</BodyText>
        </Badge>
      </div>
    ) : (
      <Button
        size="xs"
        type="button"
        onClick={() => onAdd(snomedCode)}
        isLoading={isPending}
        className="shrink-0 transition-none bg-button-superclinical text-button-primary border border-ai"
      >
        Add
      </Button>
    )}
  </div>
);
